export const moduleNamespace = 'addonManager';

export const SET_RESALE_ADDONS = 'SET_RESALE_ADDONS';
export const SET_ADDON_PRICE = 'SET_ADDON_PRICE';
export const ENABLE_ADDON_PRICE_IF_REQUIRED = 'ENABLE_ADDON_PRICE_IF_REQUIRED';
export const REMOVE_ADDON_BY_STRIPE_ID = 'REMOVE_ADDON_BY_STRIPE_ID';
export const SET_ERRORS = 'SET_ERRORS';
export const CLEAR_ADDON_CONFIGURATION = 'CLEAR_ADDON_CONFIGURATION';
